<template>
  <div v-if="loading" class="flex h-full justify-center items-center">
    <loading-spinner diameter="64px" />
  </div>

  <alert-badge
    v-else-if="error.title"
    isDanger
    :title="error.title"
    :body="error.body"
    @dismissed="
      () => {
        error.title = ''
        error.body = ''
      }
    "
  />

  <delivery-form
    v-else
    :initDelivery="initDelivery"
    :successMsg="$t('actions.saveChangesSuccess')"
    :submitAction="update"
  />
</template>

<script lang="ts">
import { defineComponent, onBeforeMount, ref } from 'vue'

import { useHTTP } from '@/plugins/http'

import Delivery from '@/models/delivery/Delivery'

// components
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import DeliveryForm from '@/views/companies/deliveries/DeliveryForm.vue'
import AlertBadge from '@/components/AlertBadge.vue'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
  name: 'delivery',
  components: {
    LoadingSpinner,
    DeliveryForm,
    AlertBadge
  },
  setup() {
    const initDelivery = ref(new Delivery())
    const error = ref({ title: '', body: '' })
    const http = useHTTP()
    const loading = ref(true)
    const route = useRoute()
    const router = useRouter()


    onBeforeMount(async () => {
      const url = `${Delivery.ENDPOINT}/${route.params.id}`

      try {
        const resp = await http.get<Delivery>(url)
        initDelivery.value = Delivery.from(resp)
      } catch (errorResp) {
        error.value.title = errorResp.title
        error.value.body = errorResp.body
      }

      loading.value = false
    })

    const update = async (delivery: Delivery) => {
      try {
        const url = `${Delivery.ENDPOINT}/${delivery.id}`
        const resp = await http.put<Delivery>(url, delivery)
        initDelivery.value = Delivery.from(resp)
        router.back();
      } catch (error) {
        return error
      }
    }

    return {
      initDelivery,
      error,
      loading,
      update
    }
  }
})
</script>
